import { render, staticRenderFns } from "./suplicencelinfonoteHistory.vue?vue&type=template&id=12da7c16&scoped=true"
import script from "./suplicencelinfonoteHistory.vue?vue&type=script&lang=js"
export * from "./suplicencelinfonoteHistory.vue?vue&type=script&lang=js"
import style0 from "./suplicencelinfonoteHistory.vue?vue&type=style&index=0&id=12da7c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da7c16",
  null
  
)

export default component.exports